var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgWheel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 155.9 0.8 283.5 283.5",
    height: 852.90253,
    viewBox: "155.9 .8 852.90253 852.90253",
    width: 852.90253,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "matrix(3.0084745 0 0 3.0084745 -313.12117 -1.60678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m228.7 102.1c3.5-6 7.8-11.5 12.7-16.4l-41.6-45.7c-10.5 10-19.4 21.6-26.4 34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.8 69.8c6.3 2.9 12.2 6.6 17.5 10.9l41.8-45.6c-11-9.5-23.5-17.3-37-23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.9 82.4-55.8 28.7c2.6 6.2 4.5 12.7 5.5 19.6l62-6.9c-1.7-14.6-5.8-28.5-11.7-41.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.2 103.1 55.4-27.6c-6.9-12.7-15.6-24.3-25.9-34.3l-41.8 45.6c4.8 4.8 8.9 10.3 12.3 16.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.7 142.5c0-1.2 0-2.5.1-3.7l-61.6-5.5c-.2 3.1-.3 6.1-.3 9.2 0 11.8 1.5 23.3 4.2 34.3l59.5-17.1c-1.2-5.6-1.9-11.3-1.9-17.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.4 193.1c-4.4 5.3-9.4 10.1-15 14.2l32.5 52.6c12.1-8.2 22.8-18.2 31.9-29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.5 142.5c0 5.8-.6 11.5-1.8 17l59.5 17.1c2.7-10.9 4.2-22.3 4.2-34.1 0-2.9-.1-5.8-.3-8.7l-61.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.8 194.3-49.2 37.4c9.2 11.2 20 21.1 32.2 29.1l32.5-52.6c-5.7-3.9-10.9-8.6-15.5-13.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.7 129.8c1.1-7 3.1-13.6 5.9-19.9l-55.3-27.6c-6.1 13-10.3 27.1-12.2 41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.3 264.7-32.5-52.6c-5.9 3.3-12.3 5.9-19 7.7l11.5 60.9c14.3-3.3 27.8-8.8 40-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.3 168.1c-2.2 6.3-5 12.3-8.6 17.8l49.4 37.3c8-11.5 14.4-24.3 18.7-38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.2 221.6c-3.8.6-7.6.8-11.5.8-3.2 0-6.3-.2-9.3-.5l-11.4 60.9c6.8 1 13.7 1.5 20.8 1.5 7.8 0 15.5-.6 23-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.7 62.7c6.9.4 13.5 1.7 19.8 3.8l22.2-57.7c-13.2-4.7-27.3-7.4-42-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.5 220.3c-6.9-1.6-13.5-4.1-19.6-7.4l-32.5 52.7c12.5 7.2 26.2 12.5 40.7 15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.6 66.2c6.4-2 13.2-3.3 20.2-3.6v-61.8c-14.9.4-29.2 3.1-42.6 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.4 187.2c-3.9-5.8-7.1-12.1-9.4-18.9l-59.5 17.1c4.5 14.2 11.2 27.4 19.7 39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.1 79.8c5.2-4.1 11-7.6 17.1-10.4l-22.4-57.7c-13.3 5.6-25.6 13.2-36.5 22.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgWheel);
export default __webpack_public_path__ + "static/media/SDG-wheel.497114cd5fa8a922f2c5251e63e71a31.svg";
export { ForwardRef as ReactComponent };